import {Component, signal} from '@angular/core';
import {MatCard, MatCardContent, MatCardHeader, MatCardTitle} from '@angular/material/card';
import {MatIcon} from '@angular/material/icon';
import {ResearchPaperDTO} from '../../../research/dto/research-paper';

@Component({
  selector: 'app-paper-overlay',
  imports: [
    MatCard,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
    MatIcon
  ],
  templateUrl: './paper-overlay.component.html',
  styleUrl: './paper-overlay.component.scss'
})
export class PaperOverlayComponent {

  paper = signal<ResearchPaperDTO | undefined>(undefined);
}
